import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";
import cmsClient from "src/services/cmsClient";

interface MoveKeyShoutOptions {
	id: number;
	offset: number;
}

const moveKeyShout = async ({ id, offset }: MoveKeyShoutOptions) => {
	const url = `/homepage/admin/keyshout/${id}/move/`;
	const response = await cmsClient.put<unknown>(url, { offset });

	return response.data;
};

const useMoveKeyShout = () => {
	const queryClient = useQueryClient();

	const onSuccess = () => {
		queryClient.invalidateQueries(["key-shouts"]);
	};

	const onError = () => {
		toast.error(
			<CustomToast type="Error" message="Something went wrong reordering" />,
			{ hideProgressBar: true }
		);
	};

	const mutation = useMutation(moveKeyShout, {
		onError,
		onSuccess
	});

	return mutation;
};

export default useMoveKeyShout;
